import { formatNumber } from "../lib/format";

const COLORS = {
    "Exceptional Flip Candidate": "hsl(var(--deep-green))",
    "Strong Candidate": "hsl(var(--champagne))",
    "Needs Deeper Due Diligence": "hsl(35 90% 50%)",
    "Weak Candidate": "hsl(var(--muted-foreground))",
    Avoid: "hsl(var(--destructive))",
};

export const FlipScoreGauge = ({ score, label, size = 140, testid }) => {
    if (score === null || score === undefined) {
        return (
            <div
                className="flex flex-col items-center justify-center text-center px-4"
                style={{ width: size, height: size }}
                data-testid={testid}
            >
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
                    Not scored
                </div>
                <div className="kpi-value text-4xl text-muted-foreground mt-1">
                    —
                </div>
            </div>
        );
    }

    const safeScore = Math.max(0, Math.min(100, score));
    const radius = size / 2 - 10;
    const circumference = 2 * Math.PI * radius;
    const dash = (safeScore / 100) * circumference;
    const color = COLORS[label] || "hsl(var(--accent))";

    return (
        <div
            className="relative flex items-center justify-center"
            style={{ width: size, height: size }}
            data-testid={testid}
        >
            <svg width={size} height={size} className="rotate-[-90deg]">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="hsl(var(--muted))"
                    strokeWidth={6}
                    fill="transparent"
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={color}
                    strokeWidth={6}
                    strokeDasharray={`${dash} ${circumference - dash}`}
                    strokeLinecap="round"
                    fill="transparent"
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="kpi-value text-4xl" style={{ color }}>
                    {formatNumber(safeScore, 0)}
                </div>
                <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">
                    Flip Score
                </div>
            </div>
        </div>
    );
};
